import { render, staticRenderFns } from "./UserActivities.vue?vue&type=template&id=262d6196&"
import script from "./UserActivities.js?vue&type=script&lang=js&"
export * from "./UserActivities.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports